// var $ = require('jquery');

module.exports = {
	init: function () {
        $('.count').countUp();
    }
}
